import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Sidebar from '../components/Sidebar';
import './Tires.css';

function Tires({ onLogout }) {
  const navigate = useNavigate();
  const [tires] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');

  return (
    <div className="home-container">
      <Sidebar onLogout={onLogout} />
      <div className="main-section">
        <div className="tires-container">
          <header className="tires-header">
            <button className="app-back-button" onClick={() => navigate('/inventory')}>
              Back
            </button>
            <h1>Tires/Batterys</h1>
            <button className="btn-add">+ Add Tire/Battery</button>
          </header>

          <div className="tires-content">
            <div className="search-box">
              <input
                type="text"
                placeholder="Search tires/batterys..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>

            {tires.length === 0 ? (
              <div className="empty-state">
                <div className="empty-icon">T</div>
                <h2>No Tires/Batterys Found</h2>
                <p>Start adding tires and batterys to your inventory</p>
              </div>
            ) : (
              <div className="tires-table">
                <table>
                  <thead>
                    <tr>
                      <th>Tire Size</th>
                      <th>Brand</th>
                      <th>Model</th>
                      <th>Stock</th>
                      <th>Price</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {tires.map((tire, index) => (
                      <tr key={index}>
                        <td>{tire.size}</td>
                        <td>{tire.brand}</td>
                        <td>{tire.model}</td>
                        <td>{tire.stock}</td>
                        <td>${tire.price}</td>
                        <td>
                          <button className="btn-edit">Edit</button>
                          <button className="btn-delete">Delete</button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Tires;
